import {createDomainEvent, DomainEvent} from './domain-event'
import {Product, ProductVariant} from '@/src/core/domain/entities/product'

export const ProductDetailEventTypes = {
  ViewProduct: 'product.view',
  BuyProduct: 'product.buy',
} as const

export const ProductListEventTypes = {
  ViewCategory: 'product-list.view',
} as const

export interface ProductBuyPayload {
  product: Product
  variant?: ProductVariant
}

export interface ProductViewPayload {
  id: Id
}

export type ProductBuyEvent = DomainEvent<ProductBuyPayload>
export type ViewProductEvent = DomainEvent<ProductViewPayload>
export type ViewCategoryEvent = DomainEvent<ProductViewPayload>

export const ProductListEvents = {
  buyProduct(payload: ProductBuyPayload): ProductBuyEvent {
    return createDomainEvent(ProductDetailEventTypes.BuyProduct, payload)
  },
  categoryView(payload: ProductViewPayload): ViewCategoryEvent {
    return createDomainEvent(ProductListEventTypes.ViewCategory, payload)
  },
}
export const ProductDetailEvents = {
  productView(payload: ProductViewPayload): ViewProductEvent {
    return createDomainEvent(ProductDetailEventTypes.ViewProduct, payload)
  },
}
